<template>
  <List :mapState="'schoolRoutesMonitors'" :allDispatch="'schoolRoutesMonitorsAll'"></List>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
  name: 'Lists',
  components: {
    List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/schoolroutes/monitors/list.vue